import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { WithHoldingTaxRateDto } from "../../../../dtos/catalogs/withholdingtaxrate/WithHoldingTaxRateDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import WithHoldingTaxRateDetailSkeleton from "./WithHoldingTaxRateDetailSkeleton";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import WithHoldingTaxRateDetailMain from "./WithHoldingTaxRateDetailMain";

interface IProps {
  model: WithHoldingTaxRateDto | null;
  modelUpdatedEvent: (newModel: WithHoldingTaxRateDto) => void;
}

interface WithHoldingTaxRateModel {
  name?: string;
  uniqueCode?: string;
  createdDate?: string;
  description?: string;
  paymentType?: number;
  categoryOfIncomeReceivers?: number;
  rate?: number;
  referenceType?: number;
  createdUserId?: string;
  id: string;
}

export const WithHoldingTaxRateDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const companyLegalFormLookup = [
    { id: 0, name: "Legal Entity" },
    { id: 1, name: "Private Person" }
  ];
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<WithHoldingTaxRateModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("description", model.description);
      setValue("paymentType", model.paymentType);
      setValue("categoryOfIncomeReceivers", model.categoryOfIncomeReceivers);
      setValue("rate", model.rate);
      setValue("referenceType", model.referenceType);
      setValue("createdUserId", model.createdUserId);
    }
  }, [model]);

  const handleFormSubmit = (action: DocumentSaveActionType, data: WithHoldingTaxRateModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: WithHoldingTaxRateDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <WithHoldingTaxRateDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <WithHoldingTaxRateDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
